import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'
import { SPACING } from '@common/theme/spacing'
import NonDicomViewerHost, { NonDicomViewerHostProps } from './NonDicomViewerHost'

export type NonDicomViewerModalProps = NonDicomViewerHostProps & {
  open: boolean
  onClose: () => void
}

export default function NonDicomViewerModal({ open, onClose, ...hostProps }: NonDicomViewerModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="non-dicom-viewer-dialog-title"
      data-testid="non-dicom-viewer-modal"
    >
      <DialogTitle id="non-dicom-viewer-dialog-title" sx={{ pb: SPACING.spacingSm }}>
        <Stack>
          <Typography color="text.primary" variant="subtitle2">
            {hostProps.fileName || 'Preview'}
          </Typography>
          {hostProps.fileExtension && (
            <Typography color="text.secondary" variant="body2">
              {hostProps.fileExtension.toUpperCase()}
            </Typography>
          )}
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: '#F0F4F5', display: 'flex', alignItems: 'center', minHeight: 400 }}>
        <NonDicomViewerHost {...hostProps} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="contained" aria-label="Close preview">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
